import { FC, useCallback, useEffect } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { IAdminProgramCodeFormValues } from '@interfaces/adminProgramCodes';
import { handleAdminCreateNewProgramCode } from '@store/features/adminProgramCodes/actions';
import { removeAdminProgramCodeDetails } from '@store/features/adminProgramCodes/slice';
import useDispatch from '@store/hooks/useDispatch';
import { EventType, useEventBus } from '@utils/eventBus';
import handleToast from '@utils/handleToast';

import ProgramCodeDetailsForm from '../ProgramCodeDetailsForm/ProgramCodeDetailsForm';

import { convertFormValuesToCreateNewPayload, validateForm } from './utils';

const initialValues = {
  riskLevels: [],
  drugClasses: [],
};

const NewProgramCode: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const eventBus = useEventBus('adminCreateNewProgramCode');

  const handleSubmit = useCallback(
    (values: IAdminProgramCodeFormValues) => {
      const payload = convertFormValuesToCreateNewPayload(values);
      return dispatch(handleAdminCreateNewProgramCode(payload));
    },
    [dispatch],
  );

  const handleCancel = useCallback(() => {
    dispatch(removeAdminProgramCodeDetails());
  }, [dispatch]);

  useEffect(() => {
    eventBus.on(EventType.ADMIN_CREATE_NEW_PROGRAM_CODE_SUCCESS, () =>
      handleToast('success', t('admin.createNewProgramCodeSuccess')),
    );

    return () => eventBus.off(EventType.ADMIN_CREATE_NEW_PROGRAM_CODE_SUCCESS);
  }, [t, eventBus]);

  return (
    <Form
      // @ts-ignore because of custom props
      component={ProgramCodeDetailsForm}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isNew
    />
  );
};

export default NewProgramCode;
